"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
var _encryption = _interopRequireDefault(require("../encryption"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Money = exports["default"] = /*#__PURE__*/function (_Core) {
  function Money(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Money);
    _this = _callSuper(this, Money, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.init();
    _this.cryptoKey = props.cryptoKey;
    _this.publicKey = props.publicKey;
    _this.services = props.services;
    _this.ready = false;
    _this.myServices = ["dpm"];
    _this.checkReadyRetryCount = 0;
    _this.maxCheckReadyRetries = 20;
    _this.checkReadyRetryDelay = 3000;
    return _this;
  }

  // Helper method to generate consistent timestamps
  (0, _inherits2["default"])(Money, _Core);
  return (0, _createClass2["default"])(Money, [{
    key: "generateTimestamp",
    value: function generateTimestamp() {
      return Number(BigInt(Date.now()) * 1000000n);
    }
  }, {
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      var found = false;
      Object.keys(this.services).forEach(function (key) {
        if (_this2.myServices.includes(key)) {
          found = true;
        }
      });
      return found;
    }
  }, {
    key: "getPeripheralsInfo",
    value: function () {
      var _getPeripheralsInfo = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var command, uuid, origin, timestamp, encryptedPayload, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              command = "System.PeripheralsManager.GetMoneyAcceptorsInfo";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: command,
                params: {}
              }, uuid, origin, timestamp);
            case 1:
              encryptedPayload = _context.sent;
              _context.next = 2;
              return this.connection.invoke("messaging", encryptedPayload);
            case 2:
              _context.next = 3;
              return this.waitForResponse(command, uuid, this.services["dpm"]);
            case 3:
              return _context.abrupt("return", _context.sent);
            case 4:
              _context.prev = 4;
              _t = _context["catch"](0);
              console.error("Error in getPeripheralsInfo:", _t);
              throw _t;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 4]]);
      }));
      function getPeripheralsInfo() {
        return _getPeripheralsInfo.apply(this, arguments);
      }
      return getPeripheralsInfo;
    }()
  }, {
    key: "getAcceptorStatus",
    value: function () {
      var _getAcceptorStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(acceptor) {
        var command, uuid, origin, timestamp, payload, _t2;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              command = "System.PeripheralsManager.GetAcceptorStatus";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context2.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: command,
                params: {
                  device: acceptor
                }
              }, uuid, origin, timestamp);
            case 1:
              payload = _context2.sent;
              _context2.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context2.next = 3;
              return this.waitForResponse(command, uuid, this.services["dpm"]);
            case 3:
              return _context2.abrupt("return", _context2.sent);
            case 4:
              _context2.prev = 4;
              _t2 = _context2["catch"](0);
              console.error("Error in getAcceptorStatus:", _t2);
              throw _t2;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 4]]);
      }));
      function getAcceptorStatus(_x) {
        return _getAcceptorStatus.apply(this, arguments);
      }
      return getAcceptorStatus;
    }()
  }, {
    key: "changeAcceptorStatus",
    value: function () {
      var _changeAcceptorStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(acceptor, status) {
        var acc, sts, command, uuid, origin, timestamp, payload, _t3;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              acc = acceptor.charAt(0).toUpperCase() + acceptor.slice(1);
              sts = status.charAt(0).toUpperCase() + status.slice(1);
              command = "System.PeripheralsManager.".concat(acc, "Acceptor").concat(sts);
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context3.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: command,
                params: {}
              }, uuid, origin, timestamp);
            case 1:
              payload = _context3.sent;
              _context3.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context3.next = 3;
              return this.waitForResponse(command, uuid, this.services["dpm"]);
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 4:
              _context3.prev = 4;
              _t3 = _context3["catch"](0);
              console.error("Error in changeAcceptorStatus:", _t3);
              throw _t3;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 4]]);
      }));
      function changeAcceptorStatus(_x2, _x3) {
        return _changeAcceptorStatus.apply(this, arguments);
      }
      return changeAcceptorStatus;
    }()
  }, {
    key: "virtualMoneyInsert",
    value: function () {
      var _virtualMoneyInsert = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(device, amount) {
        var command, uuid, origin, timestamp, payload, _t4;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              command = "System.PeripheralsManager.VirtualMoneyInsert";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context4.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: command,
                params: {
                  device: device,
                  amount: amount
                }
              }, uuid, origin, timestamp);
            case 1:
              payload = _context4.sent;
              _context4.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context4.next = 3;
              return this.waitForResponse(command, uuid, this.services["dpm"]);
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 4:
              _context4.prev = 4;
              _t4 = _context4["catch"](0);
              console.error("Error in virtualMoneyInsert:", _t4);
              throw _t4;
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 4]]);
      }));
      function virtualMoneyInsert(_x4, _x5) {
        return _virtualMoneyInsert.apply(this, arguments);
      }
      return virtualMoneyInsert;
    }()
  }, {
    key: "changeAcceptorStatusAll",
    value: function () {
      var _changeAcceptorStatusAll = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(bool) {
        var action, command, uuid, origin, timestamp, payload, _t5;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              action = bool ? "Start" : "Stop";
              command = "System.PeripheralsManager.AllAcceptors".concat(action);
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context5.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: command,
                params: {}
              }, uuid, origin, timestamp);
            case 1:
              payload = _context5.sent;
              _context5.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context5.next = 3;
              return this.waitForResponse(command, uuid, this.services["dpm"]);
            case 3:
              return _context5.abrupt("return", _context5.sent);
            case 4:
              _context5.prev = 4;
              _t5 = _context5["catch"](0);
              console.error("Error in changeAcceptorStatusAll:", _t5);
              throw _t5;
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 4]]);
      }));
      function changeAcceptorStatusAll(_x6) {
        return _changeAcceptorStatusAll.apply(this, arguments);
      }
      return changeAcceptorStatusAll;
    }()
  }, {
    key: "getCheckReady",
    value: function () {
      var _getCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var payload, _t6;
        return _regenerator["default"].wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              payload = {
                action: "System.PeripheralsManager.CheckReady",
                uuid: (0, _uuid.v4)(),
                origin: "sdk-" + this.appName,
                request_uuid: "",
                timestamp: this.generateTimestamp(),
                data: "{}"
              };
              _context6.next = 1;
              return this.connection.invoke("messaging", payload);
            case 1:
              _logger["default"].info("Check Ready", "Checking if everything is ready", "Money");
              _context6.next = 3;
              break;
            case 2:
              _context6.prev = 2;
              _t6 = _context6["catch"](0);
              console.error("Error in getCheckReady:", _t6);
              throw _t6;
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function getCheckReady() {
        return _getCheckReady.apply(this, arguments);
      }
      return getCheckReady;
    }()
  }, {
    key: "waitForResponse",
    value: function () {
      var _waitForResponse = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(command, uuid, service) {
        var _this3 = this;
        return _regenerator["default"].wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", new Promise(function (resolve, reject) {
                var resolved = false;
                var timeout = setTimeout(function () {
                  if (!resolved) {
                    resolved = true;
                    _this3.connection.off("messaging", _messageHandler);
                    reject(new Error("Response timeout for command: ".concat(command, ", UUID: ").concat(uuid)));
                  }
                }, 30000);
                var _messageHandler = /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(msg) {
                    var _jsonObject$response, decryptedData, jsonObject, errorMessage, error, _t7;
                    return _regenerator["default"].wrap(function (_context7) {
                      while (1) switch (_context7.prev = _context7.next) {
                        case 0:
                          if (!resolved) {
                            _context7.next = 1;
                            break;
                          }
                          return _context7.abrupt("return");
                        case 1:
                          if (!(msg.action === "System.SDK.ServiceCall" && msg.requestUuid === uuid)) {
                            _context7.next = 6;
                            break;
                          }
                          _context7.prev = 2;
                          resolved = true;
                          clearTimeout(timeout);
                          _this3.connection.off("messaging", _messageHandler);
                          _context7.next = 3;
                          return _encryption["default"].decryptSymmetrically(service, msg.data);
                        case 3:
                          decryptedData = _context7.sent;
                          jsonObject = JSON.parse(decryptedData);
                          if (!((jsonObject === null || jsonObject === void 0 || (_jsonObject$response = jsonObject.response) === null || _jsonObject$response === void 0 ? void 0 : _jsonObject$response.success) === false)) {
                            _context7.next = 4;
                            break;
                          }
                          errorMessage = jsonObject.response.message || "Unknown error from service";
                          error = new Error(errorMessage);
                          error.name = "ServiceCallError";
                          error.code = command;
                          _logger["default"].error("Service Error", errorMessage, "Money");
                          return _context7.abrupt("return", reject(error));
                        case 4:
                          resolve(jsonObject.params);
                          _context7.next = 6;
                          break;
                        case 5:
                          _context7.prev = 5;
                          _t7 = _context7["catch"](2);
                          _logger["default"].error("Decrypt Error", _t7.message, "Money");
                          reject(new Error("Failed to decrypt data."));
                        case 6:
                        case "end":
                          return _context7.stop();
                      }
                    }, _callee7, null, [[2, 5]]);
                  }));
                  return function messageHandler(_x0) {
                    return _ref.apply(this, arguments);
                  };
                }();
                _this3.connection.on("messaging", _messageHandler);
              }));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function waitForResponse(_x7, _x8, _x9) {
        return _waitForResponse.apply(this, arguments);
      }
      return waitForResponse;
    }()
  }, {
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(message) {
        var origin, _origin$split, _origin$split2, serviceName, target, _JSON$parse, ready, coinNotification, billNotification, eventsNotification, _t8;
        return _regenerator["default"].wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              origin = message.origin || "";
              _origin$split = origin.split("-"), _origin$split2 = (0, _slicedToArray2["default"])(_origin$split, 2), serviceName = _origin$split2[0], target = _origin$split2[1]; // "dpm" ili "dpm-demoApp"
              if (this.myServices.includes(serviceName)) {
                _context9.next = 1;
                break;
              }
              return _context9.abrupt("return");
            case 1:
              if (!(target && target !== this.appName && target !== this.randomNumber)) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              _t8 = message.action;
              _context9.next = _t8 === "System.SDK.ServiceNotification.Response" ? 3 : _t8 === "System.PeripheralsManager.Notify.Ready" ? 4 : _t8 === "System.PeripheralsManager.Notify.CoinBlockers" ? 5 : _t8 === "System.PeripheralsManager.Notify.BillBlockers" ? 6 : _t8 === "System.PeripheralsManager.Notify.Events" ? 7 : 8;
              break;
            case 3:
              // ključeve spremaj pod *serviceName* (ne pod cijeli origin), jer origin može biti "dpm" ili "dpm-demoApp"
              this.services[serviceName] = JSON.parse(message.data);
              return _context9.abrupt("continue", 9);
            case 4:
              _JSON$parse = JSON.parse(message.data || "{}"), ready = _JSON$parse.ready;
              if (ready) {
                this.checkReadyRetryCount = 0;
                this.maybeFinishInitialization();
              } else {
                this.retryCheckReady();
              }
              return _context9.abrupt("continue", 9);
            case 5:
              coinNotification = JSON.parse(message.data || "{}");
              this.trigger("coinStartBlockers", coinNotification);
              return _context9.abrupt("return");
            case 6:
              billNotification = JSON.parse(message.data || "{}");
              this.trigger("billStartBlockers", billNotification);
              return _context9.abrupt("return");
            case 7:
              eventsNotification = JSON.parse(message.data || "{}");
              this.trigger("dpmEvents", eventsNotification);
              return _context9.abrupt("return");
            case 8:
              return _context9.abrupt("continue", 9);
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function handleMessage(_x1) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "maybeFinishInitialization",
    value: function maybeFinishInitialization() {
      if (!this.ready) {
        this.ready = true;
        this.trigger("ready", true);
        _logger["default"].success("Initialization", "Module is now fully ready", "Money");
      }
    }
  }, {
    key: "retryCheckReady",
    value: function () {
      var _retryCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee0() {
        var _this4 = this;
        return _regenerator["default"].wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              if (this.checkReadyRetryCount < this.maxCheckReadyRetries) {
                this.checkReadyRetryCount++;
                setTimeout(function () {
                  _this4.getCheckReady();
                }, this.checkReadyRetryDelay);
              } else {
                _logger["default"].error("Retry Failed", "Peripheral not ready after maximum retries", "Money");
                this.trigger("ready", false);
              }
            case 1:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this);
      }));
      function retryCheckReady() {
        return _retryCheckReady.apply(this, arguments);
      }
      return retryCheckReady;
    }()
  }, {
    key: "init",
    value: function init() {
      _logger["default"].info("Initialization", "Module initialization started, detecting services", "Money");
      this.checkReadyRetryCount = 0;
      if (!this.detectServices()) {
        _logger["default"].warn("Initialization", "No services found. In most cases, this is okay, services will show up soon.", "Money");
      } else {
        _logger["default"].success("Initialization done", "Module is now ready", "Money");
      }
      this.getCheckReady();
      this.connection.on("messaging", this.handleMessage.bind(this));
    }
  }]);
}(_core["default"]);